
  <template>
  <v-footer height='auto' color="white" inset width='100%'>
    <v-layout justify-center row wrap>
      <span class="format-word">
        <strong>Copyright</strong>
        ©2019 DB1 Global Software
      </span>
    </v-layout>
  </v-footer>
</template>
<script>
export default {

};
</script>
<style lang="sass" scoped>
@import '@/assets/sass/styles.sass'

.format-word
  @extend %format-font-dark
  font-weight: 500
  font-size: 8px
  line-height: 24px

</style>
